var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-pje-objetivo"},[_c('div',{key:_vm.key,staticClass:"chart-pje-objetivo-outter"},[_c('div',{class:{ 
          'chart-pje-objetivo-inner': true,
          'amarillo': _vm.pjeActual >= 90,
          'verde': _vm.pjeActual >= 100
        },style:({ width: _vm.pjeAvance + '%'})},[_c('span',{class:{ 
        'chart-pje-objetivo-valor': true,
        'light': _vm.pjeActual > 60
      },style:("color: " + _vm.getContrastingTextColor() + ";")},[_vm._v(_vm._s(_vm._f("numero")(_vm.pjeActual,2, true))+"%")])])]),_c('p',{staticClass:"description"},[_vm._v(_vm._s(_vm.descripcion))])])
}
var staticRenderFns = []

export { render, staticRenderFns }